import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clickToEditCopyPasteHeading: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-heading',
		defaultMessage: 'Edit issues inline, or copy and paste',
		description: 'Heading of the first step in the copy paste onboarding.',
	},
	clickToEditCopyPasteHeadingIssueTermRefresh: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-heading-issue-term-refresh',
		defaultMessage: 'Edit work items inline, or copy and paste',
		description: 'Heading of the first step in the copy paste onboarding.',
	},
	clickToEditCopyPasteBodyMac: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-body-mac',
		defaultMessage:
			'Select a cell to quickly edit details. To copy and paste without editing, select <code>esc</code> then <code>command</code> + <code>C</code> / <code>V</code>.',
		description: 'Description of the first step in the copy paste onboarding.',
	},
	clickToEditCopyPasteBodyWindows: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-copy-paste-body-windows',
		defaultMessage:
			'Select a cell to quickly edit details. To copy and paste without editing, select <code>esc</code> then <code>ctrl</code> + <code>C</code> / <code>V</code>.',
		description: 'Description of the first step in the copy paste onboarding.',
	},
	clickToEditNavigationHeading: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-heading',
		defaultMessage: 'Navigate with your keyboard',
		description: 'Heading of the second step in the copy paste onboarding.',
	},
	clickToEditNavigationBodyMac: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-body-mac',
		defaultMessage:
			'Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>return</code> to edit details, and <code>esc</code> to exit edit mode.',
		description: 'Description of the second step in the copy paste onboarding.',
	},
	clickToEditNavigationBodyWindows: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-edit-navigation-body-windows',
		defaultMessage:
			'Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>enter</code> to edit details, and <code>esc</code> to exit edit mode.',
		description: 'Description of the second step in the copy paste onboarding.',
	},
	clickToSelectCopyPasteHeading: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-heading',
		defaultMessage: 'Copy and paste details, just like a spreadsheet',
		description: 'Heading of the first step in the copy paste onboarding.',
	},
	clickToSelectCopyPasteBodyMac: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-mac',
		defaultMessage:
			'To copy and paste issue details, select a cell then <code>command</code> + <code>C</code> / <code>V</code>. Select the cell again to edit.',
		description: 'Description of the first step in the copy paste onboarding.',
	},
	clickToSelectCopyPasteBodyWindows: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-windows',
		defaultMessage:
			'To copy and paste issue details, select a cell then <code>ctrl</code> + <code>C</code> / <code>V</code>. Select the cell again to edit.',
		description: 'Description of the first step in the copy paste onboarding.',
	},
	clickToSelectCopyPasteBodyMacIssueTermRefresh: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-mac-issue-term-refresh',
		defaultMessage:
			'To copy and paste work item details, select a cell then <code>command</code> + <code>C</code> / <code>V</code>. Select the cell again to edit.',
		description: 'Description of the first step in the copy paste onboarding.',
	},
	clickToSelectCopyPasteBodyWindowsIssueTermRefresh: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-copy-paste-body-windows-issue-term-refresh',
		defaultMessage:
			'To copy and paste work item details, select a cell then <code>ctrl</code> + <code>C</code> / <code>V</code>. Select the cell again to edit.',
		description: 'Description of the first step in the copy paste onboarding.',
	},
	clickToSelectNavigationHeading: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-heading',
		defaultMessage: 'Navigate with your keyboard',
		description: 'Heading of the second step in the copy paste onboarding.',
	},
	clickToSelectNavigationBodyMac: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-body-mac',
		defaultMessage:
			'Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>return</code> to edit details, and <code>esc</code> to exit edit mode.',
		description: 'Description of the second step in the copy paste onboarding.',
	},
	clickToSelectNavigationBodyWindows: {
		id: 'business-list.list-view.text-cell.copy-paste-onboarding.click-to-select-navigation-body-windows',
		defaultMessage:
			'Select a cell then use <code>tab</code> and arrow keys to navigate your list. Use <code>enter</code> to edit details, and <code>esc</code> to exit edit mode.',
		description: 'Description of the second step in the copy paste onboarding.',
	},
});
